"use client";

import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { usePathname } from "next/navigation";

export default function AOSInit() {
  const pathname = usePathname();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });

    // Refresh AOS when route changes
    setTimeout(() => {
     AOS.refreshHard();  
    }, 100);
  }, [pathname]); // <- Refresh AOS whenever route/path changes

  return null;
}
